import {globalActions} from '../../store/global-actions';
import {disableHtmlScrollMixin} from '../mixins/component-mixins';

function initSearchFilterComponent(app) {
    app.component('search-filter', {
        template: '#search-filter',
        props: {
            mainFilters: {},
            basicFilters: {},
            extendedFilters: {},
            hiddenFilters: {},
            backgroundId: {},
            isActive: {},
        },
        mixins: [disableHtmlScrollMixin],
        data() {
            return {
                isExpanded: this.isActive,
            };
        },
        computed: {
            tags() {
                return this.mainFilters
                    .concat(this.basicFilters)
                    .concat(this.extendedFilters)
                    .concat(this.hiddenFilters)
                    .reduce(function(result, filter) {
                        if (filter.isValueSet()) {
                            result = result.concat(filter.getTags());
                        }

                        return result;
                    }, []);
            },
            hasFilters() {
                return this.tags && this.tags.length > 0;
            },
        },
        watch: {
            isActive(val) {
                this.isExpanded = val;
            },
            isExpanded(val) {
                this.$emit('update:isActive', val);
            },
        },
        methods: {
            clearFilter(filter, value) {
                filter.clear(value);
                globalActions.triggerFilterDeepUpdate(filter._filterKey);
            },

            toggleMore() {
                this.isExpanded = !this.isExpanded;
            },
        },
    });
}

export default initSearchFilterComponent;
